import type { ClonePurchaseTerms } from './utils/microsoftPurchaseTermsUtil'
import type { AzureOfferPlan, Installments, PrivateOffer } from '../types'

// Inline ResellerInfo to avoid circular dependency with resaleAuthorizations/reducer.ts
export type AWSPartnerTier = 'registered' | 'select' | 'advanced' | 'premier'

export interface ResellerInfo {
  resellerCompanyName?: string
  labraPlatformResellerId?: string
  geoLocation?: string
  resellerAwsAccountId?: string
  crmAwsResellerObjectId?: string
  awsPartnerTier?: AWSPartnerTier
}

export type KeyValue = {
  key: string
  value: string | boolean | number | ResellerInfo[] | null | undefined
}

export const initialPricesObject = {
  price1m: '',
  price12m: '',
  price24m: '',
  price36m: '',
  subscriptionPrice: '',
  additionalUsagePrice: '',
  price: '',
}

export enum PrivateOfferFields {
  DIMENSIONS = 'dimensions',
  INSTALLMENTS = 'installments',
  OFFER_RECIPIENTS = 'offerRecipients',
  PLANS = 'plans',
}

export type PrivateOfferErrors = {
  errors: Record<string, unknown>
  hasBeenSent: boolean
  noOfTimesSaved: number
}

export type OffersWithErrors = PrivateOffer & PrivateOfferErrors

export interface PrivateOfferObjectInCreation {
  [x: string]: OffersWithErrors
}

export interface PrivateOffersInCreation {
  currentPrivateOfferInCreation: PrivateOfferObjectInCreation
  clonePurchaseTerms: ClonePurchaseTerms | null
}

export interface getInstallmentErrorsProps {
  installments: Installments[]
  installmentErrors: Array<Record<string, unknown>>
  offerExpirationDate: string
  agreementStartDate?: string
  serviceOrDurationLength?: number
  isResale?: boolean
}

export interface getPlansErrorProps {
  plans: AzureOfferPlan[]
  errors: Record<string, unknown>[]
  field?: string
  index?: number
  subIndex?: number
  meter?: string
  deleteBillingTerms?: boolean
}

export interface getAzureDatesErrorProps {
  privateOffer: PrivateOffer
  timeZone: string
  errorsCopy: Record<string, unknown>
}

export interface getInstallmentAmountErrorProps {
  amountValue?: number
}

export interface getServiceLengthOrDurationErrorProps {
  lengthValue?: number
  errKeyText: string
}

export interface getMetadataErrorProps {
  metaData: Array<Record<string, string>>
  errors: Record<string, unknown>
  field?: string
  index?: number
}
